import useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';

import { ModalCoordinationContext, type ModalCoordinationContextType } from './ModalCoordinationContext';

/**
 * Centralizes modal coordination for the subscription-management surface so
 * domain components read from one place instead of each calling
 * `useGlobalModals`. The `global` stack is URL-driven (`?modal=`); the `local`
 * stack is a single shared instance so cross-domain components can drive the
 * same General-tab modals.
 */
export const ModalCoordinationProvider = ({ children }: { children: React.ReactNode }) => {
  const global = useGlobalModals();
  const local = useGlobalModals({ useLocalState: true });

  const value: ModalCoordinationContextType = { global, local };

  return <ModalCoordinationContext.Provider value={value}>{children}</ModalCoordinationContext.Provider>;
};
